export default function(status, prefix, type = undefined) {
    
    var suffix = "";
    if(type) {
        suffix = ("s-konec-type-"  + (type.toLowerCase()));
    }
    
    switch (status) {
        case 'VÝZVA' : return prefix+'s-vyzva';
        case 'VÝJEZD' : return prefix+'s-vyjezd';
        case 'MÍSTO' : return prefix+'s-misto';
        case 'TRANSFER_DO_ZZ' : return prefix+'s-transfer-do-zz';
        case 'PŘEDÁNÍ_ZZ' : return prefix+'s-predani-zz';
        case 'NA_PŘÍJMU' : return prefix+'s-na-prijmu';
        case 'KONEC' : return prefix+'s-konec'+ (suffix ? " "+prefix+suffix : "");
        case 'MIMO_PROVOZ_SERVIS' : return prefix+'s-mimo-provoz';
        case 'PAUZA' : return prefix+'s-pauza';
        default: ''
    }
}